// Estructura de contenido del sitio. Edita los textos aquí.

export const SECTIONS = [
  {
    key: "conocenos",
    path: "/conocenos",
    title: "Conócenos",
    color: "magenta",
    ready: true,
    intro:
      "Somos Juventudes Latentes, una asociación civil que desde hace una década forma liderazgos adolescentes y juveniles que transforman a México con perspectiva de género.",
    image: "https://images.pexels.com/photos/8553167/pexels-photo-8553167.jpeg",
    subpages: [
      {
        slug: "quienes-somos",
        title: "Quiénes somos",
        ready: true,
        intro: "Una organización joven, plural y comprometida con la equidad de género.",
        body: [
          "Juventudes Latentes acompaña a adolescentes y jóvenes para que desarrollen su liderazgo y generen cambios en sus comunidades.",
          "Trabajamos con enfoque de derechos humanos, perspectiva de género e interseccionalidad.",
        ],
        bullets: [
          "Asociación de la sociedad civil sin fines de lucro.",
          "10 años de trabajo con juventudes en México.",
          "Presencia territorial junto a las comunidades.",
        ],
      },
      {
        slug: "nuestros-consejos",
        title: "Nuestros consejos",
        ready: true,
        intro: "Los órganos que guían y acompañan nuestro trabajo.",
        body: [
          "Contamos con un consejo directivo y consejos consultivos que orientan nuestra estrategia y aseguran la transparencia.",
          "Personas con trayectoria en género, juventudes, educación e incidencia aportan su experiencia.",
        ],
        bullets: ["Consejo directivo", "Consejo consultivo", "Comité juvenil"],
      },
      {
        slug: "alianzas",
        title: "Alianzas",
        ready: true,
        intro: "Construimos en red con quienes comparten nuestra causa.",
        body: [
          "Sumamos esfuerzos con organizaciones, instituciones educativas, fundaciones y sector público.",
          "Las alianzas multiplican el alcance y la sostenibilidad de nuestros programas.",
        ],
        bullets: ["Organizaciones aliadas", "Sector educativo", "Aliados financiadores"],
      },
      {
        slug: "informes-de-resultados",
        title: "Informes de Resultados",
        ready: true,
        intro: "Rendimos cuentas de cada aporte.",
        body: ["Consulta nuestros informes y conoce el impacto y el uso responsable de los recursos."],
        bullets: ["Informes anuales", "Indicadores de impacto", "Transparencia"],
      },
    ],
  },
  {
    key: "programas",
    path: "/programas",
    title: "Programas",
    color: "orange",
    ready: true,
    intro:
      "Diseñamos programas que acompañan a las juventudes en su liderazgo, su formación y su bienestar, siempre con perspectiva de género.",
    image: "https://images.pexels.com/photos/8923849/pexels-photo-8923849.jpeg",
    subpages: [
      {
        slug: "clubs",
        title: "Clubs",
        ready: true,
        intro: "Espacios juveniles de organización y acción comunitaria.",
        body: [
          "Los clubs son grupos donde las juventudes se organizan, aprenden y generan proyectos para transformar su entorno.",
        ],
        bullets: ["Espacios seguros", "Autogestión acompañada", "Proyectos comunitarios"],
      },
      {
        slug: "el-jardin",
        title: "El Jardín (Newsletter)",
        ready: true,
        intro: "Nuestro newsletter: historias, herramientas y voces de las juventudes.",
        body: [
          "El Jardín es el newsletter de Juventudes Latentes. Un espacio para sembrar ideas y florecer en comunidad.",
        ],
        bullets: ["Historias reales", "Herramientas para la vida", "Noticias de la red"],
      },
      {
        slug: "tejiendo-redes-ciudadanas",
        title: "Tejiendo Redes Ciudadanas por Juventudes Diversas",
        ready: true,
        intro: "5ta edición del Concurso Nacional (INE x Juventudes Latentes).",
        body: [
          "Juventudes Latentes se suma como aliada estratégica a la 5ta edición de este concurso nacional.",
        ],
        bullets: ["Concurso Nacional", "ENCÍVICA 2024-2026", "Juventudes diversas"],
      },
      {
        slug: "programa-de-acompanamiento",
        title: "Programa de Acompañamiento",
        ready: true,
        intro: "Acompañamos de cerca el desarrollo de cada liderazgo.",
        body: [
          "Brindamos mentoría y seguimiento personalizado a quienes participan en nuestros procesos.",
        ],
        bullets: ["Mentorías", "Seguimiento personalizado", "Redes de apoyo"],
      },
      {
        slug: "escuela-de-formacion",
        title: "Escuela de Formación de Liderazgos Adolescentes",
        ready: true,
        intro: "Formación integral para liderazgos adolescentes.",
        body: [
          "Un proceso formativo que fortalece habilidades de liderazgo, vocería, trabajo en equipo y perspectiva de género.",
        ],
        bullets: ["Currícula formativa", "Talleres prácticos", "Certificación de procesos"],
      },
      {
        slug: "laboratorio-de-incidencia",
        title: "Laboratorio de Incidencia Pública",
        ready: true,
        intro: "Llevamos la voz de las juventudes a los espacios de decisión.",
        body: [
          "Acompañamos a jóvenes para diseñar propuestas e incidir en políticas públicas con perspectiva de género.",
        ],
        bullets: ["Participación ciudadana", "Diálogo con autoridades", "Propuestas de política pública"],
      },
      {
        slug: "stem-bienestar",
        title: "STEM para el Bienestar Social",
        ready: true,
        intro: "Ciencia y tecnología con sentido social y de género.",
        body: [
          "Impulsamos el acceso de las juventudes a las áreas STEM para resolver problemas de sus comunidades.",
        ],
        bullets: ["Mujeres y niñas en STEM", "Proyectos de impacto", "Tecnología con propósito"],
      },
    ],
  },
  {
    key: "recursos",
    path: "/recursos",
    title: "Recursos",
    color: "lime",
    intro:
      "Compartimos materiales y herramientas para que más personas puedan abrir clubs y abordar los temas de género con responsabilidad.",
    image: "https://images.pexels.com/photos/6966370/pexels-photo-6966370.jpeg",
    subpages: [
      {
        slug: "para-clubs",
        title: "Para Clubs",
        ready: true,
        intro: "Todo lo necesario para acompañar a un club.",
        body: ["Materiales, dinámicas y guías pensadas para quienes facilitan o coordinan un club."],
        bullets: ["Material descargable", "Dinámicas grupales", "Planeaciones"],
      },
      {
        slug: "protocolos-de-seguridad",
        title: "Protocolos de Seguridad",
        ready: true,
        intro: "Cuidado y entornos seguros para las juventudes.",
        body: ["Protocolos para prevenir y actuar frente a situaciones de riesgo o violencia."],
        bullets: ["Prevención", "Rutas de actuación", "Buenas prácticas"],
      },
      {
        slug: "guias-de-lenguaje",
        title: "Guías prácticas de DDHH",
        ready: true,
        intro: "Hablar con respeto e inclusión.",
        body: ["Guías para usar un lenguaje incluyente y respetuoso en nuestros espacios y materiales."],
        bullets: ["Lenguaje incluyente", "Recomendaciones prácticas", "Ejemplos"],
      },
      {
        slug: "faqs",
        title: "FAQs",
        ready: true,
        intro: "Resolvemos tus dudas más frecuentes.",
        body: ["Encuentra respuestas a las preguntas más comunes sobre nuestros programas y clubs."],
        bullets: ["Sobre los clubs", "Sobre voluntariado", "Sobre donaciones"],
      },
    ],
  },
  {
    key: "red-de-clubs",
    path: "/red-de-clubs",
    title: "Red de Clubs",
    color: "yellow",
    ready: true,
    intro:
      "Nuestra Red de Clubs conecta a grupos juveniles que impulsan la equidad de género en sus territorios. Juntas y juntos somos más fuertes.",
    image: "https://images.pexels.com/photos/7081113/pexels-photo-7081113.jpeg",
    subpages: [
      {
        slug: "directorio-de-clubs",
        title: "Directorio de Clubs",
        ready: true,
        intro: "Conoce los clubs que forman parte de la red.",
        body: ["Explora las comunidades y regiones donde ya existen clubs activos."],
        bullets: ["Clubs activos", "Presencia territorial", "Crecimiento constante"],
      },
      {
        slug: "como-abrir-un-club",
        title: "Cómo Abrir un Club",
        ready: true,
        intro: "Te acompañamos paso a paso para iniciar tu club.",
        body: ["Conoce el proceso, los requisitos y el acompañamiento que brindamos para abrir un club."],
        bullets: ["Requisitos", "Proceso de apertura", "Acompañamiento"],
      },
      {
        slug: "transicion-de-liderazgos",
        title: "Transición de Liderazgos",
        ready: true,
        intro: "Para que los clubs sean sostenibles en el tiempo.",
        body: ["Herramientas para acompañar el relevo y la continuidad de los liderazgos dentro de cada club."],
        bullets: ["Relevo generacional", "Continuidad", "Memoria del club"],
      },
    ],
  },
  {
    key: "donaciones",
    path: "/donaciones",
    title: "Donaciones",
    color: "magenta",
    ready: true,
    hidden: true,
    intro:
      "Tu apoyo hace posible que más juventudes accedan a programas, recursos y espacios seguros. Cada aporte cuenta.",
    image: "https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg",
    subpages: [
      {
        slug: "dona-ahora",
        title: "Dona Ahora",
        ready: true,
        intro: "Tu aporte se transforma en liderazgos que cambian a México.",
        body: ["Con tu donación sostenemos talleres, materiales y acompañamiento para las juventudes."],
        bullets: ["Donación única", "Donación mensual", "Apoyo en especie"],
        isDonate: true,
      },
    ],
  },
  {
    key: "contacto",
    path: "/contacto",
    title: "Contacto",
    color: "orange",
    intro:
      "¿Quieres colaborar, sumarte o saber más? Escríbenos un mensaje y te responderemos pronto.",
    image: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg",
    subpages: [],
  },
];

export const MILESTONES = [
  { year: "2026", title: "Laboratorio de Incidencia Pública", text: "Lanzamos el Laboratorio de Incidencia Pública para Juventudes, en alianza con Borde Político.", color: "magenta" },
  { year: "2024", title: "+10,000 juventudes formadas", text: "Superamos las 10,000 juventudes formadas en nuestros programas.", color: "orange" },
  { year: "2020", title: "Nos consolidamos en México", text: "Nos consolidamos en México y abrimos nuestra primera oficina presencial.", color: "lime" },
  { year: "2019", title: "Escuela de Liderazgos Adolescentes", text: "Lanzamos la Escuela de Fortalecimiento de Liderazgos Adolescentes, junto a UNICEF e INMUJERES.", color: "yellow" },
  { year: "2016", title: "Nace Juventudes Latentes", text: "Comenzamos trabajando en América Latina, como parte de la Fundación de las Naciones Unidas.", color: "magenta" },
];

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/latentes.mx/" },
  { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61592414407783" },
  { name: "TikTok", url: "https://www.tiktok.com/@latentesmx" },
  { name: "LinkedIn", url: "https://mx.linkedin.com/company/latentesmx" },
];

export const getSection = (key) => SECTIONS.find((s) => s.key === key);
